import { Link } from "react-router-dom";
import type { Drama } from "@/lib/queries";

type DramaCardProps = {
  drama: Drama;
  showSummary?: boolean;
};

export default function DramaCard({ drama, showSummary = true }: DramaCardProps) {
  return (
    <Link
      to={`/detail/${drama.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden pb-[133%]">
        <img
          src={drama.cover}
          alt={`${drama.title} 剧集封面`}
          title={`${drama.title} 剧情介绍与演员资料`}
          className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-2.5 top-2.5 rounded-full px-2.5 py-1 text-[11px] font-label ${
            drama.status === "连载"
              ? "bg-primary-600 text-background-50"
              : "bg-secondary-800/85 text-background-50"
          }`}
        >
          {drama.status}
        </span>
        <span className="absolute right-2.5 top-2.5 flex items-center gap-1 rounded-full bg-foreground-950/55 px-2.5 py-1 text-[11px] font-label text-background-50">
          <i className="ri-fire-line text-accent-400" />
          {drama.heat}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-3.5 md:p-4">
        <h3 className="line-clamp-1 font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {drama.title}
        </h3>
        <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs font-label text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" />
            {drama.year}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-movie-2-line" />
            {drama.episodes}集
          </span>
        </div>
        {showSummary && (
          <p className="mt-2.5 line-clamp-2 text-xs leading-6 text-foreground-600 md:text-[13px]">
            {drama.summary}
          </p>
        )}
        <div className="mt-3 flex items-center justify-between border-t border-background-200 pt-3 text-[11px] font-label text-foreground-400">
          <span>{drama.category}</span>
          <span>{drama.updateTime} 更新</span>
        </div>
      </div>
    </Link>
  );
}